import React, { type ComponentProps } from "react"

import { CustomTimePicker } from "./CustomTimePicker.tsx"

type FollowUpTimePickerProps = Omit<
  ComponentProps<typeof CustomTimePicker>,
  "format" | "minuteStep" | "use12Hours"
>

/** A follow-up is always selected on a 12-hour clock in quarter-hour steps. */
export function FollowUpTimePicker(props: FollowUpTimePickerProps) {
  return (
    <CustomTimePicker
      {...props}
      format={"h:mm A"}
      minuteStep={15}
      use12Hours
    />
  )
}
